// AUTO-GENERATED GraphQL Builder for ServiceCategory
import * as Builders from '../';
export class ServiceCategoryBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  code(){ return this.add('code'); }
  label(){ return this.add('label'); }
  color(){ return this.add('color'); }
  sortOrder(){ return this.add('sortOrder'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  bookingPackageList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageList'))return this;
    this.v.add('bookingPackageList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  bookingSlotSelectionList(b?:(q:Builders.BookingSlotSelectionBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingSlotSelectionList'))return this;
    this.v.add('bookingSlotSelectionList');
    const n=new Builders.BookingSlotSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingSlotSelectionList { ${inner} }`);
    return this;
  }

  checklistItemList(b?:(q:Builders.ChecklistItemBuilder)=>void){
    if(this.depth>=5||this.v.has('checklistItemList'))return this;
    this.v.add('checklistItemList');
    const n=new Builders.ChecklistItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`checklistItemList { ${inner} }`);
    return this;
  }

  offeringList(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringList'))return this;
    this.v.add('offeringList');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringList { ${inner} }`);
    return this;
  }

  offeringSlotList(b?:(q:Builders.OfferingSlotBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringSlotList'))return this;
    this.v.add('offeringSlotList');
    const n=new Builders.OfferingSlotBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSlotList { ${inner} }`);
    return this;
  }

  vendorList(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorList'))return this;
    this.v.add('vendorList');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorList { ${inner} }`);
    return this;
  }

  reverseBookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  reverseBookingSlotSelection(b?:(q:Builders.BookingSlotSelectionBuilder)=>void){
    const n=new Builders.BookingSlotSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingSlotSelectionList { ${inner} }`);
    return this;
  }

  reverseOffering(b?:(q:Builders.OfferingBuilder)=>void){
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringList { ${inner} }`);
    return this;
  }

  reverseOfferingSlot(b?:(q:Builders.OfferingSlotBuilder)=>void){
    const n=new Builders.OfferingSlotBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSlotList { ${inner} }`);
    return this;
  }

  reverseVendor(b?:(q:Builders.VendorBuilder)=>void){
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorList { ${inner} }`);
    return this;
  }
}
